

import { useQuery } from "@tanstack/react-query";
import { trazabilidadXItem } from "../../../services";





export const useTrazabilidadXItem = (id) => {
    const { data, isLoading } = useQuery({
        queryKey: ['trazabilixitem', { id }], 
        queryFn: () => trazabilidadXItem(id),
    });
    
    return { data, isLoading }
}
